"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shared = exports["default"] = void 0;

var _color = require("../color.js");

/**
 * @module ol/style/IconImageCache
 */

/**
 * @classdesc
 * Singleton class. Available through {@link module:ol/style/IconImageCache.shared}.
 */
var IconImageCache =
/** @class */
function () {
  function IconImageCache() {
    /**
     * @type {!Object<string, import("./IconImage.js").default>}
     * @private
     */
    this.cache_ = {};
    /**
     * @type {number}
     * @private
     */

    this.cacheSize_ = 0;
    /**
     * @type {number}
     * @private
     */

    this.maxCacheSize_ = 32;
  }
  /**
   * FIXME empty description for jsdoc
   */


  IconImageCache.prototype.clear = function () {
    this.cache_ = {};
    this.cacheSize_ = 0;
  };
  /**
   * @return {boolean} Can expire cache.
   */


  IconImageCache.prototype.canExpireCache = function () {
    return this.cacheSize_ > this.maxCacheSize_;
  };
  /**
   * FIXME empty description for jsdoc
   */


  IconImageCache.prototype.expire = function () {
    if (this.canExpireCache()) {
      var i = 0;

      for (var key in this.cache_) {
        var iconImage = this.cache_[key];

        if ((i++ & 3) === 0 && !iconImage.hasListener()) {
          delete this.cache_[key];
          --this.cacheSize_;
        }
      }
    }
  };
  /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color} color Color.
   * @return {import("./IconImage.js").default} Icon image.
   */


  IconImageCache.prototype.get = function (src, crossOrigin, color) {
    var key = getKey(src, crossOrigin, color);
    return key in this.cache_ ? this.cache_[key] : null;
  };
  /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color} color Color.
   * @param {import("./IconImage.js").default} iconImage Icon image.
   */


  IconImageCache.prototype.set = function (src, crossOrigin, color, iconImage) {
    var key = getKey(src, crossOrigin, color);
    this.cache_[key] = iconImage;
    ++this.cacheSize_;
  };
  /**
   * Set the cache size of the icon cache. Default is `32`. Change this value when
   * your map uses more than 32 different icon images and you are not caching icon
   * styles on the application level.
   * @param {number} maxCacheSize Cache max size.
   * @api
   */


  IconImageCache.prototype.setSize = function (maxCacheSize) {
    this.maxCacheSize_ = maxCacheSize;
    this.expire();
  };

  return IconImageCache;
}();
/**
 * @param {string} src Src.
 * @param {?string} crossOrigin Cross origin.
 * @param {import("../color.js").Color} color Color.
 * @return {string} Cache key.
 */


function getKey(src, crossOrigin, color) {
  var colorString = color ? (0, _color.asString)(color) : 'null';
  return crossOrigin + ':' + src + ':' + colorString;
}

var _default = IconImageCache;
/**
 * The {@link module:ol/style/IconImageCache~IconImageCache} for
 * {@link module:ol/style/Icon~Icon} images.
 * @api
 */

exports["default"] = _default;
var shared = new IconImageCache();
exports.shared = shared;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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